<template>
  <div class="monitoringall">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        {{
          itemTitle == ""
            ? $store.state.homeitem.monitoring.videoName
            : itemTitle
        }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div id="inp">
          <input id="div-inp" text="checkbox" v-model="felice" />
          <div id="sousuo">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div v-if="IsShow > 0" class="NoShow">{{ textNo }}</div>
        <div class="hodern">
          <el-dropdown-item
            v-for="(item, index) in targetData"
            :key="index"
            :command="index"
          >
            <p>{{ item.videoName }}</p></el-dropdown-item
          >
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { GetSecurityDevices, GET_AREAS } from "../../../api/common";
export default {
  name: "png",
  data() {
    return {
      IsShow: 0,
      itemTitle: "",
      felice: "",
      id: "",
      areaId: 1,
      targetData: "",
      textNo: "",
    };
  },
  mounted() {
    GET_AREAS().then((res) => {
      // console.log(res.data.data.areas);
      let id = 0;
      let monitorArr = [];
      res.data.data.areas.forEach((item, index) => {
        GetSecurityDevices(item.areaId).then((res) => {
          // console.log(res.data.data.devices);
          res.data.data.devices.filter((item) => {
            if (item.device_class_name == "监控设备") {
              return monitorArr.push({
                id: id++,
                videoName: item.device_name,
                videoCode: JSON.parse(item.device_details).roomName,
              });
            }
          });
          this.targetData = monitorArr; //传入PNG的值
          // console.log(this.targetData);
          this.$store.commit("monitoringName", this.targetData[0]);
        });
      });
    });
  },
  watch: {
    targetData(o, n) {
      if (this.targetData.length == 0) {
        this.IsShow = 1;
        this.textNo = "暂无数据";
      } else {
        this.IsShow = 0;
        this.textNo = "";
      }
    },
    felice(val) {
      this.felice = val;
      var pnge = this.$store.state.homeitem.massage;
      this.targetData = pnge.filter((array) => {
        if (array.videoName.match(this.felice) !== null) {
          return array;
        } else if (this.felice == "") {
          return this.targetData;
        }
      });
    },
  },
  beforeDestroy() {
    this.$store.commit("apkAll", null);
  },
  methods: {
    handleCommand(command) {
      this.itemTitle = this.targetData[command].videoName;
      // console.log(this.targetData[command].videoCode);
      this.$store.commit("apkAll", this.targetData[command].videoCode);
    },
  },
};
</script>
<style scoped lang="less">
.monitoringall {
  width: 100% !important;
  position: relative;
}
.el-dropdown-link {
  left: 30rem;
  top: 20rem;
  width: 500rem;
  position: absolute;
  display: flex;
  color: #ffffff;
  font-size: 18rem;
  cursor: pointer;
  align-items: center;
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}
.el-dropdown-menu {
  width: 290rem !important;
  position: fixed !important;
  left: 16% !important;
  top: 13% !important;
}
.popper__arrow {
  margin-left: 0 !important;
}
.el-dropdown-menu__item {
  white-space: nowrap !important;
}
#inp {
  width: 248rem;
  height: 32rem;
  background: rgba(252, 250, 250, 0.15);
  border: 1rem solid rgba(0, 0, 0, 0.15);
  border-radius: 16rem;
  margin-left: 16rem;
  margin-bottom: 16rem;
  padding: 0rem 8rem 0 5rem;
  display: flex;
  justify-content: space-between;
  #div-inp {
    background: rgba(252, 250, 250, 0.15);
    color: #999999;
    .w(120);
    font-size: 16rem;
    border: none;
    outline: none;
  }
}

#sousuo {
  //  width: 18rem;
  //  height: 18rem;
  margin-left: 0rem;
  margin-top: 2%;
  .el-icon-search {
    font-size: 16rem;
  }
}
.NoShow {
  position: absolute;
  height: 24rem;
  color: gray;
  font-size: 16rem;
  text-align: center;
  top: 80rem;
  left: 0;
  right: 0;
  margin: auto;
}
.YesShow {
  height: 24rem;
  width: 100%;
}
.hodern {
  height: 300rem !important;
  max-height: 300rem;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.hodern::-webkit-scrollbar {
  width: 8rem;
  height: 72rem;
  background: #fff;
}
div::-webkit-scrollbar-track {
  width: 8rem;
  height: 72rem;
  background: #fff;
  border-radius: 4rem;
}
div::-webkit-scrollbar-thumb {
  width: 8rem;
  height: 72rem;
  background: #bfbfbf;
  border-radius: 10rem;
}
</style>